/**
 * geometry.js — pure edge geometry helpers (no React, no @xyflow imports).
 *
 * Rect shape used throughout: { x, y, width, height } where (x, y) is the top-left corner.
 */

// Intersection of the line from `rect` center to `other` center with `rect`'s border.
// Port of React Flow's floating-edge getNodeIntersection, parameterised on plain rects.
export function nodeIntersection(rect, other) {
  const w = rect.width / 2;
  const h = rect.height / 2;
  const cx = rect.x + w;
  const cy = rect.y + h;
  const ox = other.x + other.width / 2;
  const oy = other.y + other.height / 2;

  const dx = ox - cx;
  const dy = oy - cy;
  if (dx === 0 && dy === 0) return { x: cx, y: cy };

  const xx = dx / (2 * w) - dy / (2 * h);
  const yy = dx / (2 * w) + dy / (2 * h);
  const a = 1 / (Math.abs(xx) + Math.abs(yy));
  const bx = a * xx;
  const by = a * yy;
  return {
    x: w * (bx + by) + cx,
    y: h * (-bx + by) + cy,
  };
}

// Which border side of `rect` does `point` lie on → 'top' | 'right' | 'bottom' | 'left'.
export function borderSide(rect, point) {
  const nx = Math.round(rect.x);
  const ny = Math.round(rect.y);
  const px = Math.round(point.x);
  const py = Math.round(point.y);
  if (px <= nx + 1) return 'left';
  if (px >= nx + Math.round(rect.width) - 1) return 'right';
  if (py <= ny + 1) return 'top';
  if (py >= ny + Math.round(rect.height) - 1) return 'bottom';
  return 'top';
}
